import type { TFunction } from 'i18next';
import type { ReactNode } from 'react';
import React from 'react';
import type { FormatOptionLabelMeta } from 'react-select-modern';

import type { IThirdPartyDataOption } from '@feathr/blackbox';

import * as styles from './AffinityTargetingDataSelect.css';

/* UniversalSelect calls this for both the menu rows and the selected value. */
export function formatAudienceOptionLabel(
  data: IThirdPartyDataOption,
  meta: FormatOptionLabelMeta<IThirdPartyDataOption>,
  t: TFunction,
): ReactNode {
  const summary = (
    <>
      <strong>{data.Name}</strong>
      <span> | </span>
      <span>{t('{{count, number}} Person', { count: data.ActiveIDsCount })}</span>
    </>
  );

  if (meta.context === 'value') {
    return <div className={styles.single}>{summary}</div>;
  }

  return (
    <>
      <div>{summary}</div>
      <div className={styles.path}>
        <p>{data.FullPath}</p>
        <p className={styles.description}>{data.Description}</p>
      </div>
    </>
  );
}
